module.exports = __webpack_public_path__ + "static/media/2.3 Heeremans Detail Himmel.d9ddb39e.jpg";